<div class="count-widget-container flex-wrap gap-2">
  <div class="count-display">
    <span class="count-value m-0">{{ displayValue }}</span>
  </div>
  <div class="count-link max-sm:w-full max-sm:justify-start">
    <button
      matButton
      tabindex="0"
      (click)="!lockedPatient && gotTo()"
      class="underline!"
      (keydown.enter)="!lockedPatient && gotTo()"
      (keydown.space)="!lockedPatient && gotTo()"
      [class.disabled-state]="lockedPatient"
      [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
      [attr.aria-disabled]="lockedPatient"
      [attr.tabindex]="lockedPatient ? -1 : 0"
    >
      {{ 'GENERAL.view' | translate }}
      <mat-icon iconPositionEnd class="ms-2" aria-hidden="true">arrow_forward</mat-icon></button
    >
  </div>
</div>
